import React, { useEffect, useState } from 'react';
import { Box, Typography, TextField, Grid } from '@mui/material';
import PanelShell from './PanelShell';

const ScenarioPanel = ({ nodeType, nodeId, data, onChange }) => {
  const [scenarioName, setScenarioName] = useState(data?.scenarioName || '');

  useEffect(() => {
    setScenarioName(data?.scenarioName || '');
  }, [data]);

  if (nodeType !== 'Scenario') return null;

  const save = () => onChange({ label: 'Scenario', scenarioName, Title: `Scenario: ${scenarioName}` });

  return (
    <PanelShell title="Senaryo" onSave={save}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="body2" fontWeight={600} mb={1} color="text.secondary">
            Senaryo Adı
          </Typography>
          <TextField
            fullWidth
            size="small"
            value={scenarioName}
            onChange={(e) => setScenarioName(e.target.value)}
            placeholder="ör: NightMode"
          />
        </Grid>
      </Grid>
    </PanelShell>
  );
};

export default ScenarioPanel;
